import { defineComponent as _defineComponent } from 'vue'
import lottie from 'lottie-web';
import { onMounted, ref, onUnmounted } from 'vue';
import { ScreenDialog } from '@tencent/wphk-ui';
import animejs from 'animejs';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { elk } from '@tencent/ppd-base-libs';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { useActConfigStore } from '../../store/act-config';

export default /*#__PURE__*/_defineComponent({
  __name: 'join-success-dialog',
  props: {
  isNeedPreload: {
    type: Boolean,
    required: false,
  },
},
  setup(__props, { expose }) {

const props = __props


const { targetActConfig } = useActConfigStore();
const { getBiExt } = useGlobalBi();
const { spId, merchantId } = useMerchantInfo();
const audioSource = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20240114193725/success.mp3';
const animSource = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20240118001208/animi-new-tiny-0118/data.json';

const successDialog = ref();
const audioContainer = ref();
const lottieContainer = ref();
const preloadLottieContainer = ref();
const lottieObj = ref();
const onDialogHide = () => { };
// 初始化动画
const initAndPlayAnim = () => {
  if (lottieObj.value) {
    lottieObj.value?.goToAndPlay(0);
  } else {
    lottieObj.value = lottie.loadAnimation({
      container: lottieContainer.value,
      path: animSource,
      renderer: 'svg',
      loop: false,
      autoplay: true,
    });
  }
};

onUnmounted(() => {
  lottieObj.value?.destroy();
  lottieObj.value = null;
});

const preloadLottie = () => {
  lottie.loadAnimation({
    container: preloadLottieContainer.value,
    path: animSource,
    renderer: 'svg',
    loop: false,
    autoplay: false,
  });
};

/** 预加载声音 */
const preloadAudio = () => {
  if (!audioContainer.value) return;
  audioContainer.value.muted = true;
  audioContainer.value.play();
  audioContainer.value.pause();
  audioContainer.value.muted = false;
};
const showCouponInfo = () => {
  animejs({
    targets: '.coupon-img-container',
    delay: 1300,
    easing: 'linear',
    opacity: [
      { value: [0, 1], duration: 400 },
    ],
    scale: [
      { value: [0.2, 1.18], duration: 320 },
      { value: [1.18, 1], duration: 320 },
    ],
  });
};

const showSuccessDialog = () => {
  successDialog.value?.show();
  /** 播放动画 */
  initAndPlayAnim();
  setTimeout(() => {
    /** 播放声音 */
    audioContainer.value?.play();
  }, 300);
  showCouponInfo();
  elk({
    key: 'joinSuccessDialogBrow',
    str3: spId,
    str4: merchantId,
  });
};
const onClickConfirm = () => {
  successDialog.value?.hide();
};

onMounted(() => {
  if (props.isNeedPreload) {
    setTimeout(() => {
      // 错峰预加载音频资源
      preloadAudio();
      preloadLottie();
    }, 1000);
  }
});

expose({
  showSuccessDialog,
});

return { __sfc: true,props, targetActConfig, getBiExt, spId, merchantId, audioSource, animSource, successDialog, audioContainer, lottieContainer, preloadLottieContainer, lottieObj, onDialogHide, initAndPlayAnim, preloadLottie, preloadAudio, showCouponInfo, showSuccessDialog, onClickConfirm, ScreenDialog }
}

})